var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 8 8", fill: "none" }, props),
    React.createElement("path", { d: "M6.22.22a.75.75 0 1 1 1.06 1.06L4.81 3.75l2.47 2.47a.75.75 0 1 1-1.06 1.06L3.75 4.81 1.28 7.28A.75.75 0 1 1 .22 6.22l2.47-2.47L.22 1.28A.75.75 0 1 1 1.28.22l2.47 2.47L6.22.22z", fill: "#B7B7B7" })
  );
});